import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { Market } from 'api'
import { CenterPanel } from 'view/routes/routesLayout'
import { CollateralHeroPanel } from './CollateralHeroPanel'
import { CollateralGrid } from './CollateralGrid'
import { createCollateralDetailsSelector } from 'selectors/collateralSelectors'
import { WindowActions } from 'epics/windowEpic'
import { useParametricSelector } from 'utils'

const marketSelector = (_: {}, value: Market) => value
const collateralListSelector = createCollateralDetailsSelector(marketSelector)

export const CollateralScreen = ({ market }: { market?: Market }) => {
  const dispatch = useDispatch()
  const collateralList = useParametricSelector(collateralListSelector, market)

  const onTearout = useCallback(() => dispatch(WindowActions.tearoutGrid(`/quote/tearout/admin/collaterals/${market ?? ''}`)), [
    dispatch,
    market
  ])

  return (
    <CenterPanel>
      <CollateralHeroPanel onTearout={onTearout} collateralList={collateralList} />
      <CollateralGrid collateralList={collateralList} />
    </CenterPanel>
  )
}
